/** Formatações usadas só nos relatórios. */

const INTEIRO = new Intl.NumberFormat('pt-BR');
const UM_DECIMAL = new Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

export function formatarInteiro(valor: number): string {
  return INTEIRO.format(valor);
}

/** Percentual já calculado pelo backend (12.5 → "12,5%"). */
export function formatarPercentual(valor: number): string {
  return `${UM_DECIMAL.format(valor)}%`;
}

/**
 * Duração em horas, na unidade que se lê sem fazer conta.
 *
 * O backend mede tudo em horas porque é a unidade que serve às três etapas,
 * mas "0,4 h até a leitura" e "172,8 h até o agendamento" são números que o
 * leitor precisa converter de cabeça. Abaixo de uma hora vira minutos, acima
 * de dois dias vira dias.
 */
export function formatarDuracao(horas: number | null): string {
  if (horas === null || Number.isNaN(horas)) return '—';
  if (horas < 0) return '—';

  if (horas < 1) {
    const minutos = Math.round(horas * 60);
    // Arredondar 0,997 h para "60 min" seria esquisito logo abaixo do corte.
    return minutos >= 60 ? '1 h' : `${minutos} min`;
  }

  if (horas < 48) return `${UM_DECIMAL.format(horas)} h`;

  return `${UM_DECIMAL.format(horas / 24)} dias`;
}

/**
 * Rótulo de um ponto da série temporal.
 *
 * Chega como `AAAA-MM-DD` ou `AAAA-MM` — dia civil nos dois casos, por isso
 * montado à mão em vez de passar por `new Date`, que interpretaria o valor
 * como instante UTC e devolveria o dia anterior em fuso negativo.
 */
const MESES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

export function formatarPontoSerie(periodo: string): string {
  const [ano = '', mes = '', dia] = periodo.split('-');
  const nomeMes = MESES[Number(mes) - 1] ?? mes;
  return dia ? `${dia}/${mes}` : `${nomeMes}/${ano.slice(2)}`;
}

/** Versão longa do mesmo ponto, para leitores de tela e tooltip. */
export function formatarPontoSerieLongo(periodo: string): string {
  const [ano = '', mes = '', dia] = periodo.split('-');
  const nomeMes = MESES[Number(mes) - 1] ?? mes;
  return dia ? `${dia}/${mes}/${ano}` : `${nomeMes}/${ano}`;
}

/** "12 de 300 (4,0%)" — usado nas descrições de cartão. */
export function proporcao(parte: number, total: number): string {
  if (total <= 0) return formatarInteiro(parte);
  return `${formatarPercentual(Math.round((parte / total) * 1000) / 10)} do total`;
}
